var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStoreReplenishmentIconBlueClipped(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50963_31351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7474 18.0703V9.57086C30.7476 9.03715 30.597 8.51425 30.3131 8.06236C30.0291 7.61047 29.6233 7.24797 29.1423 7.01661L17.8826 1.38678C17.4804 1.17883 17.0342 1.07031 16.5814 1.07031C16.1286 1.07031 15.6824 1.17883 15.2802 1.38678L4.01773 7.01661C3.53704 7.24817 3.13151 7.61076 2.8478 8.06263C2.5641 8.5145 2.41375 9.0373 2.41406 9.57086V25.1542C2.41406 25.9056 2.71257 26.6263 3.24393 27.1577C3.77528 27.689 4.49595 27.9875 5.2474 27.9875H11.2417",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9104 11.8302C16.9104 10.6279 16.4328 9.47482 15.5826 8.62466C14.7325 7.77449 13.5794 7.29688 12.3771 7.29688C11.1097 7.30164 9.8933 7.79616 8.98212 8.67702L7.84375 9.81539M7.84375 9.81539V7.29688M7.84375 9.81539H10.3623M7.84375 11.8302C7.84375 13.0325 8.32137 14.1856 9.17153 15.0358C10.0217 15.8859 11.1748 16.3635 12.3771 16.3635C13.6444 16.3588 14.8609 15.8643 15.772 14.9834L16.9104 13.845M16.9104 13.845L14.3919 13.845M16.9104 13.845V16.3635",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.076 22.5476C31.0758 22.3027 31.0117 22.0622 30.8901 21.8501C30.7685 21.6381 30.5938 21.462 30.3834 21.3396L25.5353 18.5465C25.3247 18.4239 25.0859 18.3594 24.8427 18.3594C24.5996 18.3594 24.3607 18.4239 24.1501 18.5465L19.302 21.3396C19.0916 21.462 18.9169 21.6381 18.7953 21.8501C18.6737 22.0622 18.6096 22.3027 18.6094 22.5476V28.1338C18.6096 28.3787 18.6737 28.6192 18.7953 28.8313C18.9169 29.0433 19.0916 29.2194 19.302 29.3418L24.1501 32.1349C24.3607 32.2575 24.5996 32.322 24.8427 32.322C25.0859 32.322 25.3247 32.2575 25.5353 32.1349L30.3834 29.3418C30.5938 29.2194 30.7685 29.0433 30.8901 28.8313C31.0117 28.6192 31.0758 28.3787 31.076 28.1338V22.5476Z",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1094 21.8516L25.0934 25.3422L28.0854 23.5969L30.761 22.0361",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0938 32.3251V25.3438",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9766 20.5H14.4766",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9766 22.5H14.4766",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9766 24.5C13.7576 24.5 13.6955 24.5 14.4766 24.5",
    stroke: "#5D5FEF",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50963_31351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white",
    transform: "translate(0.476562 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreReplenishmentIconBlueClipped);
export default __webpack_public_path__ + "static/media/StoreReplenishmentIconBlueClipped.5b0a74a85dfba82cce18c77e7ba93203.svg";
export { ForwardRef as ReactComponent };